@if (isVisible()) {
  <div class="snackbar" [@slideInOut] (@slideInOut.done)="onAnimationDone($event)">
    <div class="snackbar__content">
      <outlaw-icon class="snackbar__icon" size="18px" name="copy" />
      <span class="snackbar__message" [innerHTML]="message()"></span>
    </div>
  </div>
}
